import { i18nMark } from 'lingui-react';

const messages = {
  description: i18nMark('The search results page of the application'),
  title: i18nMark('The Search Results Page'),
  pageTitle: i18nMark('Search Results: {searchValue}'),
  pageTitleNoResult: i18nMark('Search Results'),
  tabTitleAssets: i18nMark('Assets ({count})'),
  tabTitleCases: i18nMark('Cases ({count})'),
};

export default messages;



// WEBPACK FOOTER //
// ./containers/SearchResultsPage/messages.js